import { css } from 'lit';

const styles = css`
  :host {
    display: block;
    font-size: var(--loquix-message-font-size, 0.9375rem);
    line-height: var(--loquix-message-line-height, 1.6);
    font-family: var(--loquix-font-family, sans-serif);
    color: var(--loquix-text-primary, #1a1a2e);
    word-break: break-word;
  }

  /* ── Text content ── */

  .content {
    position: relative;
  }

  /* ── Code block ── */

  .code-block {
    font-family: var(--loquix-code-font-family, 'Fira Code', 'Cascadia Code', monospace);
    font-size: var(--loquix-code-font-size, 0.875em);
    line-height: var(--loquix-code-line-height, 1.5);
    background: var(--loquix-surface-secondary-bg, #f4f4f8);
    border-radius: var(--loquix-code-border-radius, 8px);
    padding: var(--loquix-code-padding, 12px 16px);
    overflow-x: auto;
    margin: 0;
    white-space: pre;
    tab-size: 2;
  }

  .code-block code {
    font-family: inherit;
    background: none;
    padding: 0;
    border-radius: 0;
  }

  /* ── Streaming cursor ── */

  .streaming-cursor {
    display: inline-block;
    width: 2px;
    height: 1.1em;
    background: var(--loquix-cursor-color, currentColor);
    margin-left: 2px;
    vertical-align: text-bottom;
    animation: loquix-blink 1s step-end infinite;
  }

  @keyframes loquix-blink {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
`;

export default styles;
